/**
 * Converts backend tokens into human-readable labels.
 *
 * Useful for enum / code values that are stored as `UPPER_SNAKE_CASE`,
 * `snake_case` or `kebab-case` but shown to end users.
 *
 *   humanize('UPDATE_STATUS')      -> 'Update Status'
 *   humanize('diagnostic_routing') -> 'Diagnostic Routing'
 *   humanize('in-app')             -> 'In App'
 */
export function humanize(value?: string | null): string {
  if (!value) return '—';

  return value
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
